"use client";

import React, { useState } from "react";
import styles from "./styles/dataset-upload.module.scss";
import { audio } from "@/data/extensions";
import UploadDragAndDrop from "@/components/common/upload-drag-and-drop";

type Props = {
  datasetFiles: File[];
  changeDatasetFiles: (value: File[]) => void;
};

const DatasetUpload = ({ datasetFiles, changeDatasetFiles }: Props) => {
  const handleFilesAdded = (files: File[]) => {
    changeDatasetFiles([...datasetFiles, ...files]);
  };

  return (
    <div className={styles.wrapper}>
      <UploadDragAndDrop
        handleFilesAdded={handleFilesAdded}
        acceptedFiles={audio}
        topText="Upload Audio"
        bottomText="Or Drag And Drop *mp3, *wav, *ogg, *m4r, *m4a, *flac, *aac, *opus File Here."
        isActive={true}
      />
    </div>
  );
};

export default DatasetUpload;
